// @ts-nocheck

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';

import Alert from '@shared/ui/alert/ui/Alert';
import Timer from '@shared/ui/timer/ui/Timer';
import DynamicScrollToTop from '@shared/ui/dynamic-scroll-to-top/ui/DynamicScrollToTop';
import RoundLoader from '@shared/ui/round-loader/ui/RoundLoader';
import { MainLayoutContainer } from '@shared/ui/main-layout-container';
import { BannerTop } from '@shared/ui/banner-top';
import { Footer } from '@shared/ui/footer';
import { Header } from '@shared/ui/header';
import { removeZerosfromPrice } from '@shared/utils/numbers';

import styles from '@features/otp-verification/styles/PinFormStyles.module.css';
import { useOTPLogic } from '@features/otp-verification/model/useOTPLogic';

export const PinFormDirectRedirect = () => {
  const { t } = useTranslation();

  const {
    pin,
    invalidLength,
    errors,
    antifraudUniqueId,
    inputId,
    redirectionDetails,
    language,
    homeData,
    subscribeData,
    operatorSelectedDetails,
    btnLoading,
    otpError,
    alerts,
    urlConfig,
    otpDigitsCount,
    minPinLength,
    maxPinLength,
    handlePinChange,
    handleSubmit,
  } = useOTPLogic({ variant: 'direct-redirect' });

  const {
    buttonConfigs: urlConfigButtonConfigs = {},
    termsAndConditions: urlConfigTermsAndConditions = {},
    otpBannerConfig: urlConfigOtpBannerConfig = {},
    textUnderOTPBanner: urlConfigTextUnderOTPBanner = {},
    textUnderOTPButton: urlConfigtextUnderOTPButton = {},
  } = Object.values(urlConfig)?.[0] || {};

  const { dcb: buttonConfigsDCB } = urlConfigButtonConfigs;
  const { dcb: termsAndConditionsDCB } = urlConfigTermsAndConditions;
  const { OTPButton: otpButtonText, OTPButtonOffer: otpButtonOfferText } = buttonConfigsDCB || {};

  const isResendOTPAvailable = !!subscribeData?.isResendOTP;

  const inputClassName = useMemo(
    () => ` pin-input-full ${errors.pin ? 'input-error' : ''}`,
    [errors]
  );

  const inputPlaceholder = Array(otpDigitsCount).fill('•').join(' ');

  const confirmPinButtonMainDefaultText = homeData?.vSubButtonOTP_Mobile || 'confirm';
  const confirmPinButtonSecondaryDefaultText =
    homeData?.vSubButtonOTP_Mobile && homeData?.vSubButtonOTP_Mobile_Offer
      ? homeData?.vSubButtonOTP_Mobile_Offer
      : null;

  const confirmPinButtonMainOperatorText =
    operatorSelectedDetails?.vSubButtonOTP_Mobile || confirmPinButtonMainDefaultText;
  const confirmPinButtonSecondaryOperatorText =
    operatorSelectedDetails?.vSubButtonOTP_Mobile &&
    operatorSelectedDetails?.vSubButtonOTP_Mobile_Offer
      ? operatorSelectedDetails?.vSubButtonOTP_Mobile_Offer
      : confirmPinButtonSecondaryDefaultText;

  const formattedOTPButtonText =
    otpButtonText?.[language?.locale] || confirmPinButtonMainOperatorText;
  const formattedOTPButtonOfferText = otpButtonText?.[language?.locale]
    ? otpButtonOfferText?.[language?.locale]
    : confirmPinButtonSecondaryOperatorText;

  const configurationsTermsAndConditionsHTML =
    termsAndConditionsDCB?.[homeData?.country]?.[language.locale];

  const formattedTextUnderBanner = urlConfigTextUnderOTPBanner?.[language.locale];
  const formattedTextUnderCTAButton = urlConfigtextUnderOTPButton?.[language.locale];

  const confirmPinTextAmountAndFrequency = `${removeZerosfromPrice(redirectionDetails.price)}${
    redirectionDetails.currency
  } ${redirectionDetails.billingOption}`;

  return (
    <>
      <Header />

      <MainLayoutContainer>
        <section className="phone-payment-section">
          <DynamicScrollToTop />

          {Object.keys(urlConfigOtpBannerConfig).length !== 0 ? (
            <div className="otp-banner-wrapper">
              <BannerTop bannerConfig={urlConfigOtpBannerConfig} />

              {formattedTextUnderBanner ? (
                <p className="text-under-otp-banner">{formattedTextUnderBanner}</p>
              ) : null}
            </div>
          ) : null}

          <form onSubmit={(e) => handleSubmit(e)}>
            <Row>
              <Col xs={12}>
                <p className={`enter-pin-code`}>{t('enter_pin')}</p>
              </Col>

              <Col xs={12}>
                <div className="text-center">
                  <div className="pin-input-divX text-center" style={{ position: 'relative' }}>
                    <input
                      className={inputClassName}
                      id={inputId}
                      type="tel"
                      minLength={minPinLength}
                      maxLength={maxPinLength}
                      onChange={(e) => handlePinChange(e)}
                      name="pin"
                      autoComplete="new-password"
                      value={pin}
                      placeholder={inputPlaceholder}
                    />
                  </div>
                  <p className="error-label-center mt-1">{errors.pin && t('invalid_pin')}</p>
                  {isResendOTPAvailable ? (
                    <Timer pin={pin} antifraudUniqueId={antifraudUniqueId} clickId={''} />
                  ) : null}
                </div>
              </Col>
            </Row>

            <Alert />

            <Row className={`mt-3`}>
              <Col xs={12} className="pin-form_buttonPrice-wrapper">
                <div className="text-center pos-rel">
                  <button
                    id="submit-otp"
                    className="vuz-btn-1 large lh-08 sub-btn-fix2"
                    disabled={btnLoading || invalidLength}
                  >
                    <div className={styles.confirmPinButton}>
                      <span className="subscribe-btn-txt">
                        {btnLoading ? <RoundLoader /> : formattedOTPButtonText}
                      </span>

                      {!btnLoading && formattedOTPButtonOfferText ? (
                        <span className={styles.pinFormOfferText}>
                          {formattedOTPButtonOfferText}
                        </span>
                      ) : null}
                    </div>
                  </button>

                  {formattedTextUnderCTAButton ? (
                    <p className="mt-3 fs-10">{formattedTextUnderCTAButton}</p>
                  ) : (
                    <p className="mt-3 fs-10">
                      {t('confirm_pin_text_1')} {confirmPinTextAmountAndFrequency}{' '}
                      {t('confirm_pin_text_2')} {redirectionDetails.operatorName} <br />{' '}
                      {t('confirm_pin_text_3')}
                    </p>
                  )}
                </div>
              </Col>
            </Row>

            <div
              className="tc-div"
              dangerouslySetInnerHTML={{
                __html: configurationsTermsAndConditionsHTML || homeData.fullTCText,
              }}
            />
          </form>
          <Footer
            vipFeaturesConfig={{ hide: false }}
            aboutUsConfig={{ onlyLinks: false }}
            isOTP={!otpError}
            isWhite={false}
          />
        </section>
      </MainLayoutContainer>
    </>
  );
};
